import { useEffect, useMemo, useState } from "react";
import { useUserState } from "../state/user";
import axios from "axios";
import { getPaidTransactionsHistory } from "../services/payments";
import { useSelectedPaymentConfiguration } from "../state/selectedPaymentConfiguration";
import { filterTransactionsByConfiguration } from "../utils/transactions";

export default function useTransactionsPaidHistory({ filters }: any) {
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { token, user, loading: loadingUser } = useUserState();
  // The API cannot filter by billing entity, so the selected company is applied
  // to the response instead of to the request.
  const { configId } = useSelectedPaymentConfiguration();

  useEffect(() => {
    (async function() {
      try {
        if (loadingUser) return;

        setLoading(true);
        setError(null);
        const result = await getPaidTransactionsHistory({
          authToken: token,
          ...(filters.dates[0] && { dataIn: filters.dates[0].toISOString() }),
          ...(filters.dates[1] && { dataEnd: filters.dates[1].toISOString() }),
          accountId: user.accountStatus.paymentId
        });
        setData(result);
      } catch (err) {
        // A cancelled request is not a failure; anything else is and has to
        // reach the UI, otherwise a failed fetch is indistinguishable from an
        // empty result.
        if (!axios.isCancel(err)) {
          setError(err as any);
        }
      } finally {
        setLoading(false);
      }
    })();
    // `error` is deliberately not a dependency: refetching because the previous
    // attempt failed would loop.
  }, [filters.dates, loadingUser, token, user.accountStatus.paymentId]);

  const visibleData = useMemo(
    () => filterTransactionsByConfiguration<any>(data, configId),
    [data, configId]
  );

  return {
    data: visibleData,
    resultsLength: visibleData?.length ?? null,
    error,
    loading
  };
}
